/* unplugin-vue-components disabled */import script from "./small-eat.vue?vue&type=script&setup=true&lang=ts"
export * from "./small-eat.vue?vue&type=script&setup=true&lang=ts"

import "./small-eat.vue?vue&type=style&index=0&id=8451e212&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8451e212"]])

export default __exports__